import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { environment } from '../../environments/environment';
import { JsonService } from '../_services/json.service';
import { LoadingService } from '../_services/loading.service';
import { LoggerService } from '../_services/logger.service';
import { IndexedDbService } from '../_services/indexed-db.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  error = '';
  urlLogin: string;

  constructor(
    private route: ActivatedRoute,
    private jsonService: JsonService,
    private router: Router,
    private loadingService: LoadingService,
    private authService: AuthenticationService,
    private logger: LoggerService,
    private db: IndexedDbService
  ) {
    this.urlLogin = environment.apiUrl;
  }

  ngOnInit(): void {
    //this.getToken();
    this.loadingService.hide();

    if (this.db.getData('id_token')) {
      this.jsonService.unlockAllPage().subscribe(
      resp => {
        //
      },
      erro => {
        this.logger.error(erro);
      }
      );
    }
  }
/*
  getToken() {
    this.route.queryParams.subscribe(params => {
      if (params['id_token']) {
        //this.logger.log('Token: ' + params['id_token']);
      }
    });
  }
*/
  async getLoginUrl() {
    const code_verifier = await this.db.getData('code_verifier');
    const code_challenge = await this.db.getData('code_challenge');
    if (code_verifier && code_challenge) {
      return this.authService.getLoginUrl(code_challenge);
    }
    return '';
  }

  async login() {
    const verifier = this.authService.generateCodeVerifier();
    const challenge = await this.authService.generateCodeChallenge(verifier);
    if(verifier && challenge){
      this.db.saveData('code_verifier', verifier);
      this.db.saveData('code_challenge', challenge);
      const loginUrl = this.authService.getLoginUrl(challenge);
      this.logger.log('Login URL:', loginUrl);
      if(loginUrl){
        window.location.href = loginUrl;
      }
    }
  }
}
